/**
 * Crawlable homepage copy. The signed-in dashboard has no long-form text, so
 * this block is rendered on every "/" response to describe what the tracker
 * does. It is visually hidden so the existing design is untouched.
 * Heading level is h2 — the visible marketing hero owns the page H1.
 */
export function HomeSeoContent() {
  return (
    <section className="sr-only" aria-hidden="false">
      <h2>Jee Tracker by The Quantum Mind</h2>
      <p>
        The Quantum Mind is a free Jee Tracker and study planner. You log what you study, and the
        app builds your daily plan around it. No notebooks, no spreadsheets, no missed revision.
      </p>
      <h3>What you can track</h3>
      <ul>
        <li>
          <strong>Syllabus:</strong> add chapters for Physics, Chemistry, Maths and Biology and see
          real completion, not guesswork.
        </li>
        <li>
          <strong>Lectures:</strong> tick lectures off and always know which one comes next.
        </li>
        <li>
          <strong>Revision:</strong> each finished lecture is scheduled again automatically.
        </li>
        <li>
          <strong>Questions:</strong> set a target per chapter and log what you solved.
        </li>
        <li>
          <strong>Tests:</strong> plan revision before a test, then record your marks.
        </li>
        <li>
          <strong>Backlogs:</strong> anything you miss moves forward instead of disappearing.
        </li>
        <li>
          <strong>Progress:</strong> streaks, rings and a calendar show how consistent you were.
        </li>
      </ul>
      <p>
        Read more about the <a href="/jee-preparation-tracker">free JEE preparation tracker</a> and
        how to use it through your preparation year.
      </p>
    </section>
  );
}
